<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">

            <div class="d-flex flex-column flex-md-row mb-4">

                <div class="d-flex align-items-start align-items-lg-center flex-column flex-lg-row">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>
                </div>

                <div class="d-flex flex-grow-0 flex-wrap justify-content-start justify-content-md-end mr-n2 w-100" v-if="object.id && getAbility()">
                    <div v-if="object.status === newsStatuses.DRAFT && (isAuthor || isSuperuser)" class="mr-2 mb-2">
                        <b-button variant="primary" size="sm"
                                  @click="onChangeStatus(newsStatuses.MODERATED)" class="mr-2"><b-icon icon="arrow-right"/> Направить на проверку</b-button>
                    </div>
                    <div v-if="object.status === newsStatuses.MODERATED && (isInController || isSuperuser)" class="mr-2 mb-2">
                        <b-button variant="success" size="sm" @click="updateStatus(newsStatuses.PUBLISHED)" class="mr-2"><b-icon icon="check"/> Опубликовать</b-button>
                        <b-button variant="danger" size="sm" @click="updateStatus(newsStatuses.DECLINED)" class="mr-2"><b-icon icon="x"/> Отклонить</b-button>
                    </div>
                    <div v-if="object.status === newsStatuses.DECLINED && (isAuthor || isSuperuser)" class="mr-2 mb-2">
                        <b-button variant="warning" size="sm" @click="updateStatus(newsStatuses.DRAFT)" class="mr-2"><b-icon icon="arrow-left"/> Взять на доработку</b-button>
                    </div>
                    <div v-if="object.status === newsStatuses.PUBLISHED && (isAuthor || isSuperuser)" class="mr-2 mb-2">
                        <b-button variant="warning" size="sm" @click="updateStatus(newsStatuses.DRAFT)" class="mr-2"><b-icon icon="arrow-left"/> Взять на доработку</b-button>
                    </div>
                    <div v-if="object.status === newsStatuses.MODERATED && (isAuthor || isSuperuser)" class="mr-2 mb-2">
                        <b-button variant="warning" size="sm" @click="updateStatus(newsStatuses.DRAFT)" class="mr-2"><b-icon icon="arrow-left"/> Взять на доработку</b-button>
                    </div>
                    <div v-if="object.status === newsStatuses.PUBLISHED && (isInController || isSuperuser)" class="mr-2 mb-2">
                        <b-button variant="danger" size="sm" @click="updateStatus(newsStatuses.DECLINED)" class="mr-2"><b-icon icon="x"/> Отозвать публикацию</b-button>
                    </div>
                </div>

            </div>

            <div class="d-flex mb-4">
                <div class="d-flex flex-column flex-grow-1">
                    <div class="d-flex flex-grow-1 align-items-baseline flex-column flex-md-row"
                         :key="objectKey + '-header'">
                        <span class="h3 mb-2 mb-lg-0" v-if="!object.id">
                            <span>Новость</span>
                        </span>
                        <span class="h3 mb-2 mb-lg-0 mr-3" v-else>{{ header }}</span>
                        <sup><small v-if="!object.id" class="text-secondary ml-2">Новая</small></sup>
                        <small  v-if="object.id" class="tag d-flex align-items-center text-nowrap">
                            <b-icon icon="circle-fill" font-scale="0.7" :variant="statusVariant" class="mr-2"/>
                            {{ statusText }}
                        </small>
                    </div>
                </div>
            </div>

            <div id="newsForm">

                <b-form-row>

                    <form-field v-if="object.authorOrganizationName"
                         class="col-xs-12 col-lg-2 m-2"
                         label="Автор"
                         :editable="false">
                        <template #value>
                            <span class="d-flex flex-column">
                                <span>{{ object.authorOrganizationName }}</span>
                            </span>
                        </template>
                    </form-field>

                    <form-field v-if="object.publicationDate"
                         class="col-xs-12 col-lg-2 m-2"
                         label="Дата публикации"
                         :editable="false">
                        <template #value>
                            <span class="d-flex flex-column">
                                <span>{{ object.pubDateStr }}</span>
                                <small class="text-secondary">{{ object.pubTimeStr }}</small>
                            </span>
                        </template>
                    </form-field>

                    <form-field v-if="object.lastReviewedAt" :label="getFieldLabel('lastReviewedAt')"
                                class="col-xs-12 col-lg-6 m-2"
                                :value="object.lastReviewedAt"
                                :editable="false">
                        <template #value>
                            <span class="d-flex flex-column">
                                <span>{{ object.lastReviewedAtDateStr }}</span>
                                <small class="text-secondary">{{ object.lastReviewedAtTimeStr }}</small>
                            </span>
                        </template>
                    </form-field>

                    <form-field
                                 class="col-xs-12 col-lg-6 required m-2"
                                 :label="getFieldLabel('title')"
                                 :editable="getAbility('title') && canWork"
                                 :value="object.title"
                                 :feedback="liveFeedback('title')">
                        <template #field>
                            <b-form-input
                                id="title"
                                class="w-100"
                                type="text"
                                v-model="$v.form.title.$model"
                                :state="validateState('title')">
                            </b-form-input>
                        </template>
                    </form-field>

                    <form-field :label="getFieldLabel('preview')"
                                class="col-xs-12 col-lg-10 col-xl-6 m-2"
                                :value="object.preview"
                                :editable="getAbility('preview') && canWork"
                                :feedback="liveFeedback('preview')">
                            <template #field>
                                    <b-form-textarea
                                        rows="4"
                                        :no-resize="true"
                                        id="preview"
                                        class="w-100"
                                         v-model="$v.form.preview.$model"
                                        :state="validateState('preview')">
                                    </b-form-textarea>
                            </template>
                    </form-field>

                    <form-field :label="getFieldLabel('body')"
                                class="col-xs-12 col-lg-10 col-xl-6 m-2"
                                :editable="getAbility('body') && canWork"
                                :feedback="liveFeedback('body')">
                            <template #value>
                                <div v-if="object.body" v-html="object.body"></div>
                                <div v-else>&mdash;</div>
                            </template>
                            <template #field>
                                <vue-editor v-model="$v.form.body.$model" :editorToolbar="editorToolbar" @text-change="onBodyChange"/>
                            </template>
                    </form-field>

                    <form-field :label="getFieldLabel('reviewComment')"
                                class="col-xs-12 col-lg-10 col-xl-6 m-2"
                                :value="object.reviewComment"
                                :editable="hasAbilityToUpdateReviewComment"
                                :feedback="liveFeedback('reviewComment')">
                            <template #field>
                                    <b-form-textarea
                                        rows="4"
                                        :no-resize="true"
                                        id="reviewComment"
                                        class="w-100"
                                         v-model="$v.form.reviewComment.$model"
                                        :state="validateState('reviewComment')">
                                    </b-form-textarea>
                            </template>
                    </form-field>

                </b-form-row>

                <b-form-row class="">
                    <gallery :label="'Фото'"
                             :root-api-url="attachmentsUrl"
                             :can-update="hasAbilityToUpdateAttachments"
                             :max-files="5"
                             :accepts="photoGalleryAccepts"
                             :upload-immediately="true"
                             :max-size="20"
                             :kind="1"
                             :existing="Boolean(objectId)"
                             :delete-on-remove="false"
                             @files-uploaded="onFilesUploaded($event, 1)"
                             @files-removed="onFilesRemoved($event, 1)"
                             ref="photoGallery"
                             class="col-xs-12 col-sm-12 col-lg-6 m-2">
                    </gallery>

                    <gallery :label="'Видео'"
                             :root-api-url="attachmentsUrl"
                             :can-update="hasAbilityToUpdateAttachments"
                             :max-files="4"
                             :accepts="videoGalleryAccepts"
                             :upload-immediately="true"
                             :max-size="10"
                             :kind="3"
                             :existing="Boolean(objectId)"
                             :delete-on-remove="false"
                             @files-uploaded="onFilesUploaded($event, 3)"
                             @files-removed="onFilesRemoved($event, 3)"
                             ref="videoGallery"
                             class="col-xs-12 col-sm-12 col-lg-6 m-2">
                    </gallery>

                    <gallery :label="'Документы'"
                             :root-api-url="attachmentsUrl"
                             :can-update="hasAbilityToUpdateAttachments"
                             :max-files="5"
                             :accepts="documentAccepts"
                             :upload-immediately="true"
                             :max-size="10"
                             :kind="2"
                             :existing="Boolean(objectId)"
                             :delete-on-remove="false"
                             :has-file-name-inputs="true"
                             @files-uploaded="onFilesUploaded($event, 2)"
                             @files-removed="onFilesRemoved($event, 2)"
                             ref="documentGallery"
                             class="col-xs-12 col-sm-12 col-lg-6 m-2">
                    </gallery>

                </b-form-row>


            </div>

            <object-form-buttons :has-changes="hasChanges"
                     :object-exists="Boolean(object.id)"
                     @object-create="onCreateStart"
                     @object-update="onUpdate"
                     @object-cancel-changes="onCancelChanges" class="mb-5"/>


        </b-card>

        <stub v-else :failed-loading="failedLoading"/>

        <confirm-save-modal ref="saveLeaveDialog">
            <template #contents>
                <span>Сохранить внесенные изменения перед отправкой на проверку?</span>
            </template>
        </confirm-save-modal>
        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>
    </div>

</template>

<script>
    import RaidsList from "../Raids/RaidsList";
    import { mapGetters } from 'vuex';
    import FormField from "../../../components/Forms/FormField";
    import { ObjectComponentMixin } from "@/components/Forms/ObjectComponentMixin";
    import api from "../../../api";
    import AnimalAvatar from "../Animals/AnimalAvatar";
    import ObjectFormButtons from "../../../components/Forms/ObjectFormButtons";
    import ConfirmLeaveModal from "../../../components/Forms/ConfirmLeaveModal";
    import SingleSelect from "@/components/Select/SingleSelect";
    import ListSelect from "@/components/Select/ListSelect";
    import DataTable from "@/components/Table/DataTable";
    import { ACTIVITIES } from "@/store/auth/auth";
    import Stub from "@/components/Stub.vue";
    import RequestStatusIndicator from "@/pages/AppPages/Requests/RequestStatusIndicator.vue";
    import MapBox from "@/components/Map/MapBox.vue";
    import {MapMixin} from "@/components/Map/mapMixin";
    import MapMunicipalityList from "@/components/Map/MapMunicipalityList.vue";
    import AnimalLink from "@/pages/AppPages/Animals/AnimalLink.vue";
    import AnimalDropdownItem from "@/pages/AppPages/Animals/AnimalDropdownItem.vue";
    import {News, NEWS_STATUS, NewsStatus} from "@/pages/AppPages/News/news";
    import Gallery from "@/components/Files/Gallery.vue";
    import { VueEditor } from "vue2-editor";
    import {RequestStatus} from "@/pages/AppPages/Requests/request";
    import ConfirmSaveModal from "@/components/Forms/ConfirmSaveModal.vue";

    export default {
        name: "NewsDetail",
        components: {
            ConfirmSaveModal,
            Gallery,
            Stub,
            DataTable,
            ListSelect,
            SingleSelect,
            FormField,
            ObjectFormButtons,
            ConfirmLeaveModal,
            VueEditor
        },
        mixins: [ ObjectComponentMixin, MapMixin ],
        validations() {
            if (this.form.activity === ACTIVITIES.CATCHING) {
                return {form: this.objectClass.catchingValidations}
            }
            return this.objectClass ? {form: this.objectClass.validations} : {}
        },
        data() {
            return {
                uploadedImageAttachments: [],
                uploadedVideoAttachments: [],
                uploadedDocumentAttachments: [],
                editorToolbar: [
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    ["bold", "italic", "underline", 'link'],
                    [{ 'align': [] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ 'color': [] }],
                ],
                resetOnEditorChange: false
            }
        },
        computed: {
            ...mapGetters(['ability', 'isMunicipalController', 'isInContractor', 'isInController',
                'isSuperuser', 'userLastValidContract', 'userLastValidContractObject', 'userValidContractObjectIds', 'userOrganizationMunicipalityNames',
                'userOrganizationId', 'userOrganizationActivities', 'userOrganizationMunicipalities', 'hasMunicipalityRestrictions']),
            attachmentsUrl() {
                const newsId = this.objectId
                if (newsId) {
                    const newsUrl = api.news.default.detail(newsId);
                    return api.news.attachments.list(newsUrl);
                }
                return api.attachments.default.list()
            },
            photoGalleryAccepts() { return ['image/jpeg', 'image/png', 'image/tiff'] },
            videoGalleryAccepts() { return ['video/mpeg', 'video/mp4'] },
            documentAccepts() { return ['image/jpeg', 'image/tiff', 'application/pdf'] },
            isAuthor() {
                return this.object.authorOrganizationId === this.userOrganizationId
            },
            canWork() {
                return this.isAuthor && this.objectId && this.object.status === NewsStatus.DRAFT || !this.objectId
            },
            hasAbilityToUpdateAttachments() {
                return this.ability.can('update', 'News') && this.canWork
            },
            hasAbilityToUpdateReviewComment() {
                return this.ability.can('update', this.object, 'reviewComment')
            },
            newsStatuses() {
                return NewsStatus
            },
            statusText() {
                return NEWS_STATUS[this.object.status]
            },
            statusVariant() {
                switch (this.object.status) {
                    case NewsStatus.DRAFT: return 'warning';
                    case NewsStatus.READY_FOR_MODERATION: return 'info';
                    case NewsStatus.MODERATED: return 'primary';
                    case NewsStatus.PUBLISHED: return 'success';
                    case NewsStatus.DECLINED: return 'danger';
                    default: return 'secondary'
                }
            },
        },
        methods: {
            onFilesUploaded(uploadedIds, kind) {
                switch (kind) {
                    case 1:
                        this.uploadedImageAttachments = [...this.uploadedImageAttachments, ...uploadedIds.ids]
                        break
                    case 2:
                        this.uploadedDocumentAttachments = [...this.uploadedDocumentAttachments, ...uploadedIds.ids]
                        break
                    case 3:
                        this.uploadedVideoAttachments = [...this.uploadedVideoAttachments, ...uploadedIds.ids]
                        break
                }
                this.$v.form.attachments.$touch();
            },

            onFilesRemoved(idsToExclude, kind) {
                const _filter = (el) => {
                    if (Array.isArray(idsToExclude)) {
                        return idsToExclude.indexOf(el) < 0
                    }
                    return idsToExclude['ids'].indexOf(el) < 0
                }
                this.form.attachments = this.form.attachments.filter(_filter)
                switch (kind) {
                    case 1:
                        this.uploadedImageAttachments = this.uploadedImageAttachments.filter(_filter)
                        break
                    case 2:
                        this.uploadedDocumentAttachments = this.uploadedDocumentAttachments.filter(_filter)
                        break
                    case 3:
                        this.uploadedVideoAttachments = this.uploadedVideoAttachments.filter(_filter)
                        break
                }
                this.$v.form.attachments.$touch();
            },

            gatherData() {
                // собрать и объединить данные со всех вложенных форм
                let formData = {}
                formData = Object.assign(formData, this.form);
                formData.attachments = [...this.form.attachments,
                    ...this.uploadedImageAttachments,
                    ...this.uploadedDocumentAttachments,
                    ...this.uploadedVideoAttachments];
                return formData
            },

            async onCreateStart(params) {
                this.create().then(async (routes) => {
                    const route = params.back ? routes.back : routes.next;
                    await this.$router.replace(route);
                });
            },

            async create() {
                const vm = this
                vm.resetOnEditorChange = true
                vm.form = vm.gatherData();
                return new Promise((resolve, reject) => {
                    this.createObject()
                        .then((result) => {
                            vm.uploadedImageAttachments = [];
                            vm.uploadedVideoAttachments = [];
                            vm.uploadedDocumentAttachments = [];
                            resolve(result)
                        }).catch((reason) => {
                            reject(reason)
                        })
                })
            },

            onUpdate() {
                const vm = this
                vm.resetOnEditorChange = true
                vm.form = vm.gatherData();
                return new Promise((resolve, reject) => {
                    vm.updateObject()
                        .then((result) => {
                            vm.uploadedImageAttachments = [];
                            vm.uploadedVideoAttachments = [];
                            vm.uploadedDocumentAttachments = [];
                            resolve(result)
                        }).catch((reason) => {
                            reject(reason)
                        })
                })
            },

            updateStatus(newStatus, extraData = {}) {
                this.$v.form.status.$model = newStatus;
                if (extraData && Object.keys(extraData)) {
                    for (const key of Object.keys(extraData)) {
                        this.$v.form[key].$model = extraData[key];
                    }
                }
                this.onUpdate();
            },

            onCancelChanges() {
                this.resetOnEditorChange = true;
                this.$refs.photoGallery.onAttachmentIdsRemoved(this.uploadedImageAttachments)
                this.$refs.documentGallery.onAttachmentIdsRemoved(this.uploadedDocumentAttachments)
                this.$refs.videoGallery.onAttachmentIdsRemoved(this.uploadedVideoAttachments)
                this.onFilesRemoved(this.uploadedImageAttachments, 1)
                this.onFilesRemoved(this.uploadedDocumentAttachments, 2)
                this.onFilesRemoved(this.uploadedVideoAttachments, 3)
                this.cancelChanges();
                this.onUpdate()
            },

            onBodyChange() {
                if (this.resetOnEditorChange) {
                    this.$v.$reset();
                    this.resetOnEditorChange = false
                }
            },

            onChangeStatus(newStatus) {
                const vm = this;
                if (vm.$v.form.$anyDirty) {
                    vm.$refs.saveLeaveDialog.showConfirmSave()
                        .then(() => { vm.updateStatus(newStatus) })
                        .catch(() => { return false });
                } else {
                     vm.updateStatus(newStatus)
                }

            }

        },
        mounted() {
            const vm = this;
            this.onMount();
            this.resetForm().then(() => {
                if (vm.$v.form.$anyDirty) {
                    vm.$v.$reset();
                }
            });
        },
        beforeMount() {
            const vm = this;
            vm.objectClass = News;
            vm.objectId = vm.$route.params.id;
            vm.apiEntryPoint = api.news;
            vm.backRoute = 'newsList';
            vm.nextRoute = 'newsDetail';

            vm.initObjectParams = {};

        }
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";
    .tag {
        background-color: lighten($primary, 42%);
        border-radius: 12px;
        padding: 5px 12px;
        margin-right: 7px;
        margin-top: 5px
    }
</style>